export default __webpack_public_path__ + "static/media/6osipc.8c2245cc.webp";